import { gql } from '@apollo/client';

export const AppContext = gql`
  query AppContext {
    me {
      id
      email
      fullName
      gid
    }
    site {
      fullstoryEnabled
      isEmailVerified
      trackingKey
      subdomain
      name
    }
  }
`;

export type AppContextQueryData = {
  me: {
    id: string;
    email: string | null;
    fullName: string | null;
    gid: string;
  } | null;
  site: {
    fullstoryEnabled: boolean | null;
    isEmailVerified: boolean | null;
    trackingKey: string | null;
    subdomain: string | null;
    name: string | null;
  } | null;
};
